import { render } from "./tick.vue?vue&type=template&id=0161bcee"
const script = {}
script.render = render

export default script